import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

export const assetsDataManagerGettingStartedEntryPoint = createEntryPoint({
	root: JSResourceForInteraction(
		() =>
			import(
				/* webpackChunkName: "async-assets-data-manager-getting-started-page", jiraSpaEntry: "async-assets-data-manager-getting-started-page" */ './src'
			),
	),
	getPreloadProps: () => ({}),
});
